var NotificationByResponseCode;
(function (NotificationByResponseCode) {
    NotificationByResponseCode["Success"] = "accept";
    NotificationByResponseCode["GeneralError"] = "error";
    NotificationByResponseCode["InValidMinBet"] = "error";
    NotificationByResponseCode["InValidMaxBet"] = "error";
    NotificationByResponseCode["InvalidBet"] = "error";
    NotificationByResponseCode["NotEnoughBalance"] = "error";
    NotificationByResponseCode["MoneyTransactionError"] = "error";
    NotificationByResponseCode["UnAuthorizedUser"] = "error";
    NotificationByResponseCode["InvalidRoundId"] = "error";
    NotificationByResponseCode["InvalidBetTime"] = "error";
    NotificationByResponseCode["InValidBetData"] = "error";
})(NotificationByResponseCode || (NotificationByResponseCode = {}));

export { NotificationByResponseCode };
